import { ColumnsType } from 'antd/es/table';
import formatCurrencyVND from 'utils/formatCurrencyVND';

export const headerRow: ColumnsType<any> = [
  {
    title: 'Mã khu vực',
    dataIndex: 'area_code',
    width: 60,
  },
  {
    title: 'Mã cửa hàng',
    dataIndex: 'plant_code',
    width: 120,
  },
  {
    title: 'Tên cửa hàng',
    dataIndex: 'plant_name',
    width: 180,
  },
  {
    title: 'Mã giỏ hàng',
    dataIndex: 'cart_code',
    width: 60,
  },
  {
    title: 'Tên giỏ hàng',
    dataIndex: 'cart_name',
    width: 120,
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
    width: 180,
  },
  {
    title: 'Loại giỏ hàng',
    dataIndex: 'cart_type_name',
    width: 60,
  },
  {
    title: 'Ngày bắt đầu',
    dataIndex: 'date_started',
    width: 120,
    render: (_: any, record: any) =>
      record.date_started ? record.date_started.slice(0, 11) : '',
  },
  {
    title: 'Ngày hết hạn',
    dataIndex: 'date_end',
    width: 180,
    render: (_: any, record: any) =>
      record.date_started ? record.date_started.slice(0, 11) : '',
  },
  {
    title: 'Người khai báo',
    dataIndex: 'created_by',
    width: 120,
  },
  {
    title: 'Ngày khai báo',
    dataIndex: 'create_at',
    width: 180,
    render: (_: any, record: any) =>
      record.create_at ? record.create_at.slice(0, 11) : '',
  },
  {
    title: 'Ngày gửi yêu cầu phê duyệt',
    dataIndex: 'request_date',
    width: 120,
    render: (_: any, record: any) =>
      record.request_date ? record.request_date.slice(0, 11) : '',
  },
  {
    title: 'Tủ xman',
    dataIndex: 'tu_xman_description',
    width: 180,
  },
  {
    title: 'Mã mẫu/SP',
    dataIndex: 'ma_mau',
    width: 180,
    render: (_: any, record: any) => record.ma_mau + '/' + record.pro_code,
  },
  {
    title: 'Tên sản phẩm',
    dataIndex: 'ten_mau',
    width: 120,
  },
  {
    title: 'Product Family',
    dataIndex: 'ooproduct_family_name',
    width: 180,
  },

  {
    title: 'Min DK',
    dataIndex: 'order_min',
    width: 180,
  },
  {
    title: 'Max DK',
    dataIndex: 'order_max',
    width: 120,
  },
  {
    title: 'Vốn Min KH',
    dataIndex: 'capital_min',
    width: 180,
  },
  {
    title: 'Vốn Max KH',
    dataIndex: 'capital_max',
    width: 120,
  },
  {
    title: 'Tồn kho hiện tại',
    dataIndex: 'tongsl_ton',
    width: 180,
  },
  {
    title: 'Aging CH',
    dataIndex: 'aging_ch',
    width: 120,
  },
  {
    title: 'Doanh thu 6 tháng',
    dataIndex: 'doanhthu_6th',
    width: 180,
    render: (value: number) => {
      return formatCurrencyVND(value);
    },
  },
  {
    title: 'Doanh số 6 tháng',
    dataIndex: 'doanhso_6th',
    width: 120,
    render: (value: number) => {
      return formatCurrencyVND(value);
    },
  },
  {
    title: 'TB Doanh thu 6 tháng',
    dataIndex: 'tb_doanh_thu_6_thang',
    width: 180,
  },
  {
    title: 'TB Doanh số 6 tháng',
    dataIndex: 'tb_doanh_so_6_thang',
    width: 120,
  },
  {
    title: 'Doanh thu kỳ vọng KV',
    dataIndex: 'doanh_thu_ki_vong_kv',
    width: 180,
    render: (value: number) => {
      return formatCurrencyVND(value);
    },
  },
  {
    title: 'Doanh số kỳ vọng KV',
    dataIndex: 'doanh_so_ki_vong_kv',
    width: 120,
    render: (value: number) => {
      return formatCurrencyVND(value);
    },
  },
  {
    title: 'Doanh thu kỳ vọng TQ',
    dataIndex: 'doanh_thu_ki_vong_tq',
    width: 180,
    render: (value: number) => {
      return formatCurrencyVND(value);
    },
  },
  {
    title: 'Doanh số kỳ vọng TQ',
    dataIndex: 'doanh_so_ki_vong_tq',
    width: 120,
    render: (value: number) => {
      return formatCurrencyVND(value);
    },
  },
  {
    title: 'Giá vốn',
    dataIndex: 'cost_price',
    width: 180,
    render: (value: number) => {
      return formatCurrencyVND(value);
    },
  },
  {
    title: 'Giá bán',
    dataIndex: 'price',
    width: 180,
    render: (value: number) => {
      return formatCurrencyVND(value);
    },
  },
  {
    title: 'PLHH',
    dataIndex: 'plhh',
    width: 180,
  },
  {
    title: 'Ngành hàng',
    dataIndex: 'nganh_hang',
    width: 120,
  },
  {
    title: 'Gán òng hàng SAP',
    dataIndex: 'dong_hang_sap',
    width: 180,
  },
  {
    title: 'Chủng loại',
    dataIndex: 'chung_loai',
    width: 120,
  },
  {
    title: 'Nhóm đặc biệt',
    dataIndex: 'nhom_dac_biet',
    width: 180,
  },
  {
    title: 'BST',
    dataIndex: 'bst_text',
    width: 120,
  },
  {
    title: 'Bộ',
    dataIndex: 'zma_bo_text',
    width: 180,
  },
  {
    title: 'Cặp',
    dataIndex: 'zma_ts_cap_text',
    width: 120,
  },
  {
    title: 'Đánh giá KV',
    dataIndex: 'danh_gia_kv',
    width: 180,
  },
  {
    title: 'Đánh giá TQ',
    dataIndex: 'danh_gia_tq',
    width: 120,
  },
  {
    title: 'Giới tính',
    dataIndex: 'gioi_tinh',
    width: 180,
  },
  {
    title: 'Phân nhóm',
    dataIndex: 'phan_nhom',
    width: 120,
  },
  {
    title: 'Size',
    dataIndex: 'size',
    width: 180,
    render: (record: any) => {
      return record[0].value;
    },
  },
  {
    title: 'Tuổi vàng',
    dataIndex: 'purity_of_gold',
    width: 120,
  },
  {
    title: 'Màu sắc',
    dataIndex: 'color',
    width: 180,
  },
];
